import { z } from "zod";

export const WhatsappDeployConfigSchema = z.object({
  call_enabled: z.boolean().default(false),

  inactivity_threshold: z
    .object({
      enabled: z.boolean().default(false),
      time_in_minutes: z.number(),
      message: z.string(),
    })
    .nullish(),

  human_handoff: z
    .object({
      enabled: z.boolean().default(false),
      use_agent_message: z.boolean().default(false),
      personal_message: z.string(),
    })
    .nullish(),

  transcription: z
    .object({
      enabled: z.boolean().default(false),
      model: z.string(),
      language: z.string().nullish(),
    })
    .nullish(),

  not_supported_message: z.string().nullish(),
});

export const agentDeployWhatsappSchema = z.object({
  organization_id: z.string().length(36),
  agent_id: z.string().length(36),
  disabled: z.boolean().default(false),
  phone_number_id: z.string().max(64),
  phone_number_status: z
    .enum(["CONNECTED", "DISCONNECTED", "PENDING_REVIEW", "UNVERIFIED"])
    .nullable(),
  display_phone_number: z.string().max(64).nullable(),
  webhook_subscription_status: z.enum(["subscribed", "unsubscribed"]).nullable(),
  waba_id: z.string().max(64),
  business_id: z.string().max(64),
  configuration: WhatsappDeployConfigSchema,
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export const agentDeployWhatsappBodySchema = agentDeployWhatsappSchema.omit({
  organization_id: true,
  created_at: true,
  updated_at: true,
  webhook_subscription_status: true,
  phone_number_status: true,
  disabled: true,
  display_phone_number: true,
});

export type AgentDeployWhatsapp = z.infer<typeof agentDeployWhatsappSchema>;
export type AgentDeployWhatsappBody = z.infer<typeof agentDeployWhatsappBodySchema>;
export type WhatsappDeployConfig = z.infer<typeof WhatsappDeployConfigSchema>;
